import clsx from 'clsx';
import React from 'react';

import largeXIcon from 'images/large_x_icon_2.svg';
import searchIcon from 'images/search_icon.svg';

import { useCloseElOnOutsideClick } from '../../../hooks';
import { search_page_path, static_index_path } from '../../../routes';
import { NavCurrentUser } from '../../../utils/backend-api/currentUser';
import NavLinks from '../NavLinks';
import navLinkStyles from '../NavLinks/styles.module.scss';
import SubscriberActions from '../SubscriberActions';
import styles from './styles.module.scss';

const CORPORATE_SUBSCRIPTION_URL = 'https://theinformation.typeform.com/to/gcz0yw';

export default function SideNav({
  closeNav,
  currentUser,
  dropdownShown,
  newForumPostsCount,
  overrideOfferCode,
  setDropdownShown,
  shouldOpenReferralModal,
  show,
}: {
  closeNav: () => void;
  currentUser: NavCurrentUser;
  dropdownShown: string;
  newForumPostsCount: number;
  overrideOfferCode?: string;
  setDropdownShown: React.Dispatch<React.SetStateAction<string>>;
  shouldOpenReferralModal: boolean;
  show: boolean;
}) {
  const { ref: sideNavRef } = useCloseElOnOutsideClick({ closeFn: closeNav, isOpen: show });

  return (
    <div className={clsx(styles.sideNav, { [styles.show]: show })} ref={sideNavRef}>
      <div className={styles.sideNavContainer}>
        <div className={clsx(styles.sideNavSection, styles.closeIconWrapper)}>
          <a className={styles.closeIcon} onClick={closeNav}>
            <img src={largeXIcon} height="24" width="30" />
          </a>
        </div>
        <NavLinks
          variant="side"
          dropdownShown={dropdownShown}
          setDropdownShown={setDropdownShown}
          newForumPostsCount={newForumPostsCount}
        />
        <SubscriberActions
          currentUser={currentUser}
          dropdownShown={dropdownShown}
          overrideOfferCode={overrideOfferCode}
          setDropdownShown={setDropdownShown}
          shouldOpenReferralModal={shouldOpenReferralModal}
          variant="side"
        />
        <div className={styles.sideNavSection}>
          <a className={navLinkStyles.navLink} href={static_index_path()}>
            About
          </a>
          <a className={navLinkStyles.navLink} href={CORPORATE_SUBSCRIPTION_URL}>
            Corporate Subscription
          </a>
          <a className={styles.searchIconWrapper} href={search_page_path()}>
            <img className={styles.navIcon} src={searchIcon} width="24" />
          </a>
        </div>
      </div>
    </div>
  );
}
